//* PIE CHART OPTIONS
export const piechartOptions: Highcharts.Options = {
  // accessibility: {
  //   enabled: true,
  //   point: {
  //     valueSuffix: '%',
  //   },
  //   keyboardNavigation: {
  //     enabled: true,
  //   },
  // },
  chart: {
    plotBackgroundColor: null,
    plotBorderWidth: null,
    plotShadow: false,
    type: 'pie',
  },
  colors: ['#01D788', '#FE5A58', '#FFCF50', '#5D62F6'],
  credits: {
    enabled: false,
  },
  plotOptions: {
    pie: {
      allowPointSelect: true,
      cursor: 'pointer',
      dataLabels: {
        enabled: false,
      },
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 400,
        },
        chartOptions: {
          legend: {
            enabled: false,
          },
        },
      },
    ],
  },
  title: {
    text: '',
  },
  tooltip: {
    pointFormat:
      '<span style="color:{point.color}">\u25CF</span>: <b>${point.y}</b> ({point.percentage:.0f}%)<br/>',
  },
  xAxis: {
    labels: {
      enabled: false,
    },
    title: {
      text: null,
    },
  },
  yAxis: {
    min: 0,
    max: 100,
    labels: {
      formatter: function () {
        return '';
      },
      style: {
        color: '#4572A7',
      },
    },
  },
};

//* BAR CHART OPTIONS
export const barchartOptions: Highcharts.Options = {
  // accessibility: {
  //   enabled: true,
  //   point: {
  //     valueSuffix: '%',
  //   },
  //   keyboardNavigation: {
  //     enabled: true,
  //   },
  // },
  chart: {
    backgroundColor: null,
    plotShadow: false,
    type: 'bar',
    height: 60,
  },
  colors: ['#FE5A58 ', '#5D62F6', '#FFCF50', '#01D788'],
  credits: {
    enabled: false,
  },
  legend: {
    enabled: false,
  },
  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>${point.y}</b> ({point.percentage:.0f}%)<br/>',
  },
  plotOptions: {
    bar: {
      stacking: 'percent',
      className: 'bar-graph',
      pointWidth: 50,
    },
    series: {
      label: {
        enabled: false,
      },
      borderWidth: 4,
      borderColor: '#fff',
    },
  },
  responsive: {
    rules: [
      {
        condition: {
          maxWidth: 350,
        },
        chartOptions: {
          legend: {
            enabled: false,
          },
        },
      },
    ],
  },
  title: {
    // text: 'Summary',
    text: null,
    style: {
      color: 'black',
      fontWeight: 'bold',
      fontSize: '1.5rem',
    },
  },
  xAxis: {
    gridLineWidth: 0,
    title: null,
    lineWidth: 0,
    tickColor: '#fff',
    labels: {
      enabled: false,
    },
  },
  yAxis: {
    gridLineWidth: 0,
    labels: {
      enabled: false,
    },
    title: null,
    tickAmount: 0,
    lineWidth: 0,
    tickColor: '#fff',
  },
};
